import Vue from 'vue'
import '../product-card/product-card.vue'

export default el => new Vue({
  name: 'hero',
  el,
})